<template>
  <table-view
    class="leave-out"
    :total="total"
    :query-info.sync="queryInfo"
    v-loading="loading"
    @reload-table="renderTable"
  >
    <template #header>
      <view-search-form
        keyword-placeholder="学生名"
        :queryInfo.sync="queryInfo"
        :tool-list="['keyword']"
        :filter-keys="['filterType']"
        style="display:inline-block"
        @on-search="renderTable(1)">
        <el-form-item prop="filterType"
                      v-if="currentRoleList.length>1"
                      label="审批角色">
          <el-select
            v-model="queryInfo.filterType"
            size="small"
            placeholder="审批状态"
            style="width: 200px;"
            @change="renderTable(1)">
            <el-option v-for="item in currentRoleList" :key="item.filterType"
                       :value="item.filterType" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item prop="leaveStatus"
                      label="审批状态">
          <el-select
            v-model="queryInfo.leaveStatus"
            clearable
            size="small"
            placeholder="审批状态"
            style="width: 100px;"
            @change="handleLeaveStatus">
            <el-option v-for="item in $store.state.systemParam.reviewStatus" :key="item.paramValue"
                       :value="item.paramValue" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item prop="verifyFlag"
                      label="销假情况">
          <el-select
            v-model="queryInfo.verifyFlag"
            size="small"
            placeholder="销假情况"
            clearable
            style="width: 200px;"
            @change="handleVerifyFlag">
            <el-option :value="0" label="未销假" />
            <el-option :value="1" label="已销假" />
          </el-select>
        </el-form-item>
        <template v-if="$store.state.login.isAdmin">
          <el-form-item v-for="(item) in filterTypeMapList" :key="item.value"
                        :prop="item.statusKey"
                        :label="item.label+'审批'">
            <el-select
              v-model="queryInfo[item.statusKey]"
              clearable
              size="small"
              placeholder="请选择审批状态">
              <el-option :value="1" label="通过" />
              <el-option :value="0" label="不通过" />
            </el-select>
          </el-form-item>
        </template>
      </view-search-form>
      <div class="header-button fr">
        <template v-if="batchCheckFlag">
          <el-button size="small" type="success" @click="handleBathCheck('pass')">批量通过</el-button>
          <el-button size="small" type="danger" plain @click="handleBathCheck('reject')">批量驳回</el-button>
        </template>
        <!--    审批状态为审批中，才能开启批量审批    -->
        <el-button :disabled="+queryInfo.leaveStatus!==1" size="small" :type="batchCheckFlag?'':'primary'"
                   @click="handleBathCheck()">
          {{ batchCheckFlag ? '关闭' : '开启' }}批量审批
        </el-button>
        <tool-tips-group is-flex>
          <template #content>
            <div> 批量销假 前置条件：</div>
            <div>1.销假状态为”未销假“；</div>
            <div>2.审批状态为”已通过“；</div>
            <div>3.勾选需要批量操作的数据；</div>
          </template>
          <el-button :disabled="queryInfo.verifyFlag!==0||!rowCheckList.length" size="small" type="primary" plain
                     @click="batchLeaveEnd">批量销假
          </el-button>
        </tool-tips-group>
        <el-button size="small" type="success" plain @click="exportMultipleForm()">批量导出请假单</el-button>
      </div>
    </template>
    <!-- body -->
    <el-table ref="tableRef" :data="tableData" style="width: 100%" border stripe
              height="100%"
              @selection-change="handleSelectChange">
      <el-table-column type="selection" width="50" align="center"
                       :selectable="handleRowSelectable" />
      <el-table-column type="index" label="ID" width="50" />
      <el-table-column prop="stuName" label="学生姓名" width="100" align="center" />
      <el-table-column prop="grade" label="年级" width="100" align="center" />
      <el-table-column prop="classesName" label="班级" min-width="200" align="center" />
      <el-table-column prop="leaveReason" label="请假原因" min-width="240px" />
      <el-table-column prop="leaveReason" label="请假时段" width="290" align="center">
        <template v-slot="{ row }">
          <span>{{ row.beginTime|formatDate('YYYY-MM-DD HH:mm') }} 至 {{ row.endTime|formatDate('YYYY-MM-DD HH:mm')
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="timeLong" label="请假时长(天)" width="110" align="center" />
      <el-table-column prop="schStatus" label="审批状态" width="80" fixed="right">
        <template v-slot="{ row }">
          <el-tag v-if="row.leaveStatus" :type="reviewStatusMap[row.leaveStatus].btnType">
            {{ reviewStatusMap[row.leaveStatus].label }}
          </el-tag>
          <el-tag v-else type="info">
            已取消
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="schStatus" label="过程" width="200px" align="center">
        <template v-slot="{ row }">
          <div v-html="DOMPurify.sanitize(parseProcess(row))"></div>
        </template>
      </el-table-column>
      <el-table-column label="附件" width="100" align="center">
        <template v-slot="{ row }">
          <div class="image" v-if="row.imgUrlList">
            <template v-if="batchCheckFlag">
              <el-image v-for="(imgUrl, index) in row.imgUrlList" :key="index"
                        style="width: 100%; height: auto; margin-right: 6px" :src="imgUrl"
                        :preview-src-list="row.imgUrlList" fit="contain" />
            </template>
            <template v-else>
              <el-popover
                placement="top"
                width="600"
                :title="`附件：${row.stuName}`"
                lazy
                trigger="hover">
                <div class="flex">
                  <el-image v-for="(imgUrl, index) in row.imgUrlList" :key="index"
                            style="width: 189px; height: auto; margin-right: 6px" :src="imgUrl"
                            :preview-src-list="row.imgUrlList" fit="contain" />
                </div>
                <el-button slot="reference" type="text" size="mini">
                  <i class="el-icon-more" style="font-size: 24px;" />
                </el-button>
              </el-popover>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="销假情况" width="90" align="center" fixed="right">
        <template v-slot="{ row }">
          {{ row.verifyFlag === 1 ? '已销假' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" fixed="right">
        <template v-slot="{ row }">
          <span class="mr-1" v-permission="auditPermitKeys">
            <el-button type="primary"
                       v-if="row.leaveStatus"
                       @click="showDialog(row.id,row)">{{ getPermitStatus(row) ? '审批' : '打印预览' }}
            </el-button>
            <el-button
              type="danger" size="mini"
              v-if="getCancelBtn(row)"
              @click="cancelReview(row)">撤回审批
            </el-button>
          </span>
          <!--          <el-button type="primary"-->
          <!--                     v-if="$store.state.login.isAdmin"-->
          <!--                     @click="showDialog(row.id,row)">打印预览-->
          <!--          </el-button>-->
          <span v-permission="['leaveAudit:teacher']">
            <el-button type="danger"
                       v-if="row.leaveStatus===3&&!row.verifyFlag"
                       @click="showSubDialog('visibleVerifyDialog','verifyDialogRef',row.id, row)"> 销假
            </el-button>
          </span>
          <el-button type="primary"
                     v-if="row.leaveStatus"
                     @click="exportSingleForm(row)">下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  请假审批 dialog  -->
    <addLeaveDialog ref="dialogRef"
                    :visible.sync="visibleDialog"
                    v-if="visibleDialog"
                    :filter-type-map-list="filterTypeMapList"
                    :audit-permit-keys="auditPermitKeys"
                    :current-leave-role="currentLeaveRole"
                    @on-close="renderTable" />
    <verify-leave-dialog ref="verifyDialogRef" :visible.sync="visibleVerifyDialog" v-if="visibleVerifyDialog"
                         @on-close="renderTable" />
  </table-view>
</template>

<script>
import { getLeaveList, deleteLeave, cancelReviewLeaveApi, batchApproveApi, batchLeaveEndApi } from '@/api/leave'
import addLeaveDialog from './component/addLeave.vue'
import store from '@/store'
import tableView from '@/vue/mixins/table-view'
import { throttle } from 'lodash'
import VerifyLeaveDialog from '@/views/pages/secondCollege/leave-out/component/verifyLeaveDialog.vue'
import DOMPurify from 'dompurify'

export default {
  components: {
    VerifyLeaveDialog,
    addLeaveDialog
  },
  mixins: [tableView],
  data() {
    return {
      DOMPurify,
      visibleVerifyDialog: false, // 销假dialog
      isExporting: false, // 是否导出状态
      reviewStatusMap: {}, // 审批状态树
      /* filterType-过滤类型：
      * 2025年3月25日以前 ：1-辅导员（所有） 2-院领导（2天以上） 3-学生处（5天及以上） 4-校领导（7天以上
      * */
      queryInfo: {
        leaveStatusNoCanal: 1,
        verifyFlag: null, // 销假状态 0-未销假 1-已销假
        filterType: store.state.login.currentLeaveRole?.filterType ?? 0,
        leaveStatus: 1, // 请假单状态 1-审批中 2 审批不通过 3 通过
        schStatus: null, // 校领导审批 1-通过 0-不通过
        subCollegeStatus: null, // 学院办公室 1-通过 0-不通过
        teacherStatus: null, // 辅导员审批 1-通过 0-不通过
        collegeStatus: null, // 院领导审批 1-通过 0-不通过
        stuOfficeStatus: null // 学生处审批 1-通过 0-不通过
      },
      filterTypeMap: store.state.login.filterTypeMap,
      filterTypeMapList: Object.values(store.state.login.filterTypeMap),
      auditPermitKeys: [], // 审批权限字段list, 通过 遍历filterTypeMapList 获取
      currentRoleList: [], // 当前用户所有审批角色List
      batchCheckFlag: false, // 是否开启批量审批
      rowCheckList: [] // table 选中的
    }
  },
  computed: {
    // 当前用户审批角色
    currentLeaveRole() {
      return this.filterTypeMap[this.queryInfo.filterType] ?? {}
    }
  },
  created() {
    this.auditPermitKeys = this.filterTypeMapList.map(item => item.permitKey)
    // 获取当前账号的所有审批角色
    this.currentRoleList = this.filterTypeMapList.filter(item => store.state.login.userInfo.paraNameList.includes(item.permitKey))
    this.reviewStatusMap = this.$store.state.systemParam.reviewStatus.reduce((prev, current) => {
      prev[current.paramValue] = current
      return prev
    }, {})
    this.renderTable(1)
  },
  methods: {
    deleteLeave, // 删除api
    // 获取外出请假列表
    async renderTable(pageNum) {
      /* 先进行角色判断获取filterType,再请求数据
      */
      if (!(this.queryInfo.filterType || this.$store.state.login.isAdmin)) return
      await this.getTableData(getLeaveList, pageNum)
      this.tableData.forEach(row => {
        if (row.imgUrlList?.length) {
          const _imgList = row.imgUrlList.map(imgUrl => `${this.$fileUrl}${imgUrl}`)
          row.imgUrlList = _imgList
        }
      })
    },
    // 是否开启批量审批
    handleBathCheck(flag) {
      if (!flag) {
        this.batchCheckFlag = !this.batchCheckFlag
        this.$refs.tableRef.clearSelection()
        this.rowCheckList = []
        return
      }
      if (!this.rowCheckList.length) {
        this.$message.warning('请先勾选需要批量审批的数据！')
        return
      }
      // 批量通过
      let _msg
      let _status = 0
      let _type = 'error'
      if (flag === 'pass') {
        _msg = '批量通过'
        _status = 1
        _type = 'success'
      } else {
        _msg = '批量驳回'
      }
      this.$confirm(`是否确认${_msg}选中的${this.rowCheckList.length}张请假单？`, '批量审批').then(async () => {
        this.loading = true
        const _formData = {
          ids: this.rowCheckList
        }
        // 判断是否为审批角色，是的话传入 statusKey
        if (this.currentLeaveRole?.statusKey) {
          _formData[this.currentLeaveRole.statusKey] = _status
        }
        try {
          await batchApproveApi(_formData)
          this.$message({
            message: `已${_msg}!`,
            type: _type
          })
          await this.renderTable()
        } catch (e) {
        } finally {
          this.loading = false
        }
      })
    },
    // 修改销假状态后，必须把 leaveStatus改为3，已通过状态，否则无法进行批量销假处理
    handleVerifyFlag() {
      this.queryInfo.leaveStatus = 3
      this.renderTable(1)
    },
    // 修改审批状态后, 除了已通过状态，leaveStatus都改为null，否则可能加载不了数据
    handleLeaveStatus(val) {
      if (+val !== 3) {
        this.queryInfo.verifyFlag = null
      }
      this.renderTable(1)
    },
    // table checkbox控制,只能选择待审批的单子
    handleRowSelectable(row) {
      if (!this.batchCheckFlag || !this.currentLeaveRole.key) return true
      return !row[this.currentLeaveRole.key]
    },
    // table 多选控制,获取选中的id
    handleSelectChange(val) {
      while (this.rowCheckList.length) {
        this.rowCheckList.pop()
      }
      if (val.length) {
        val.forEach(({ id }) => {
          this.rowCheckList.push(id)
        })
      }
    },
    // 批量导出多个请假单
    async exportMultipleForm() {
      if (!this.rowCheckList.length) {
        this.$message.warning('请先点击表格最左侧的多选框，勾选需要导出的请假单！')
        return
      }
      this.loading = true
      try {
        await this.$http.exportExcelHttp.exportMultipleLeaveOut({ ids: this.rowCheckList }, '批量导出的请假单')
        this.$message.success('批量导出成功,文件正在下载！')
        // 导出开始后，清空选中
        this.$refs.tableRef.clearSelection()
        while (this.rowCheckList.length) {
          this.rowCheckList.pop()
        }
      } catch (e) {
        return e
      } finally {
        this.loading = false
      }
    },
    // 导出单个请假单
    async exportSingleForm(row) {
      this.loading = true
      try {
        const _fileName = `${row.stuName}（${row.grade}级${row.classesName}）的请假单`
        await this.$http.exportExcelHttp.exportSingleLeaveOut(row.id, _fileName)
        this.$message.success('导出成功,文件正在下载！')
      } catch (e) {
        return e
      } finally {
        this.loading = false
      }
    },
    // 拼接审批过程
    parseProcess(row) {
      /* 天数在2天或以下：辅导员 * 天数在2天-5天:院领导 * 数是 5天以上：学生处 */
      const _processList = this.formatFilterType(row)
      const _processRows = []
      for (const {
        label,
        threshold,
        statusKey
      } of _processList) {
        if (+row.timeLong > threshold) {
          const status = this.parseStatusToStr(row[statusKey])
          if (status !== undefined && status !== null) {
            _processRows.push(`<tr><td>${label}：</td><td>${status}</td></tr>`)
          }
        }
      }
      return `<table class="process-table">${_processRows.join('')}</table>`
    },
    // 判断该账号是否已审批该申请
    getPermitStatus(row) {
      let _flag = false
      /*
      * 2025-09-01 之后有5个角色
      * 2025-03-25-2025-09-01 之间 只有3个角色
      * 2025-03-25 之前 有4个个角色
      * */
      const changeDate = this.$moment('2025-09-01T00:00:00')
      const changeDate2 = this.$moment('2025-03-25T00:00:00')
      if (this.currentLeaveRole?.key) {
        if (this.$moment(row.beginTime).isBefore(changeDate)) {
          if (this.$moment(row.beginTime).isAfter(changeDate2)) {
            if (!['subCollegeUserId', 'schUserId'].includes(this.currentLeaveRole.key)) {
              _flag = !row[this.currentLeaveRole.key]
            }
          } else {
            if (this.currentLeaveRole.key !== 'subCollegeUserId') {
              _flag = !row[this.currentLeaveRole.key]
            }
          }
        } else {
          _flag = !row[this.currentLeaveRole.key]
        }
      }
      return _flag
    },
    // 审批状态转换
    parseStatusToStr(status) {
      return status === null ? '<span class="font-grey">未审批</span>' : (status === 1 ? '<span style="color: var(--color-success)">通过</span>' : status === 0 ? '<span style="color: var(--color-danger)">不通过</span>' : '')
    },
    // 判断是否显示 撤回审批 按钮（只有当前角色有审批权限且下一级未审批时，才显示撤回按钮）
    getCancelBtn(row) {
      /*
      * 1.!!row[this.currentLeaveRole.key] - 检查当前角色是否有审批权限（字段值为真）
      * 2.this.currentLeaveRole.auditPermitKeys.every((key) => !row[key]) - 确保下一级审批人尚未审批（所有下级审批字段都为空）
      * 只有当前角色有审批权限且下一级未审批时，才显示撤回按钮
      */
      if (!row.verifyFlag) {
        if (this.currentLeaveRole?.key) {
          if (this.currentLeaveRole.auditPermitKeys.length) {
            return !!row[this.currentLeaveRole.key] && this.currentLeaveRole.auditPermitKeys.every((key) => !row[key])
          } else {
            return !!row[this.currentLeaveRole.key]
          }
        }
      }
      return false
    },
    formatFilterType(row) {
      let result = this.filterTypeMapList
      // 2025-09-01 之前 只有3个角色
      const changeDate = this.$moment('2025-09-01T00:00:00')
      if (this.$moment(row.beginTime).isBefore(changeDate)) {
        result = [
          {
            filterType: 1,
            threshold: 0,
            label: '辅导员',
            key: 'teacherUserId',
            statusKey: 'teacherStatus',
            permitKey: 'leaveAudit:teacher',
            opinionKey: 'teacherOpinion',
            editKey: 'teacher',
            auditPermitKeys: ['collegeUserId', 'stuOfficeUserId', 'schUserId']
          },
          {
            filterType: 2,
            label: '院领导',
            threshold: 2,
            key: 'collegeUserId',
            statusKey: 'collegeStatus',
            permitKey: 'leaveAudit:college',
            opinionKey: 'subCollegeOpinion',
            editKey: 'subCollege',
            auditPermitKeys: ['stuOfficeUserId', 'schUserId']
          },
          {
            filterType: 3,
            threshold: 5,
            key: 'stuOfficeUserId',
            statusKey: 'stuOfficeStatus',
            permitKey: 'leaveAudit:stuOffice',
            label: '学生处',
            opinionKey: 'stuOfficeOpinion',
            editKey: 'stuOffice',
            auditPermitKeys: ['schUserId']
          }
        ]
        // 2025-03-25 之前 存在校领导 角色
        const changeDate2 = this.$moment('2025-03-25T00:00:00')
        if (this.$moment(row.beginTime).isBefore(changeDate2)) {
          result.push(
            {
              filterType: 4,
              threshold: 7,
              label: '校领导',
              key: 'schUserId',
              statusKey: 'schStatus',
              permitKey: 'leaveAudit:sch',
              opinionKey: 'schOpinion',
              editKey: 'sch',
              auditPermitKeys: []
            }
          )
        }
      }
      return result
    },
    batchLeaveEnd: throttle(function() {
      console.log(this.$refs.tableRef.selection)
      const nameList = this.$refs.tableRef.selection.map(item => {
        return `<div>${item.stuName}（${this.$moment(item.beginTime).format('YYYY-MM-DD HH:mm')} 至 ${this.$moment(item.endTime).format('YYYY-MM-DD HH:mm')}），</div>`
      })
      this.$confirm(`<div>此操作将对以下<b>${this.rowCheckList.length}</b>名学生进行批量销假操作, 是否继续?<div>${nameList.join('')}`, '提示', { dangerouslyUseHTMLString: true }).then(async () => {
        try {
          await batchLeaveEndApi({ ids: this.rowCheckList })
          this.$confirm('批量销假操作成功！', '温馨提示', { showCancelButton: false }).then(() => {
            this.renderTable()
          })
        } catch (e) {
          console.error(e)
        }
      })
    }, 800),
    // 撤销审批状态为‘待审批’(下一级未审批之前可撤回)
    cancelReview: throttle(function(row) {
      // 当您撤回审批后，之后的所有审批流程将重置至"待审批"状态，以便您重新进入审批流程。请再次确认您是否要撤回对学生赖嘉惠的请假审批。
      this.$confirm(`<p class="confirm-message">请确认是否<b>撤回</b>学生-<b class="danger">${row.stuName}(${row.grade}级${row.classesName})</b>的请假审批【当前审批角色：${this.currentLeaveRole.label}】，重新进入审批流程？</p>`, '撤回请假审批', { dangerouslyUseHTMLString: true }).then(async () => {
        try {
          await cancelReviewLeaveApi(row.id)
          this.$message.success(`学生-${row.stuName}的${this.currentLeaveRole.formLabel}撤回成功！`)
        } catch (e) {
          if (!e) {
            this.$message.error('撤回失败，请重试！')
          }
        } finally {
          await this.renderTable(1)
        }
      })
    }, 1500)
  }
}
</script>
<style lang="scss">
.leave-out.table-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--header-height));
  box-sizing: border-box;

  .process-table {
    float: right;

    tr {
      background: transparent;

      td:first-child {
        text-align: right;
      }
    }
  }

  .table-view__body {
    flex: 1;
    overflow: hidden;
  }
}
</style>
